import React from "react";
import styled from "styled-components";
import Chart from "react-apexcharts";

// #region SCOPED CSS
const StyledChartCard = styled.div`
    &.buyplan-chart-card {
        background: var(--backgrounds-and-lines-n-400, #1e2631);
        border-radius: 4px;
        padding: 16px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        flex: 1;
        min-width: 320px;
    }

    .card-title {
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-size: var(--overline-font-size, 14px);
        letter-spacing: var(--overline-letter-spacing, 0.015em);
        font-weight: var(--overline-font-weight, 500);
        text-transform: uppercase;
    }

    .card-divider {
        border: none;
        height: 1px;
        background: #3c485a;
        width: 100%;
        margin: 0;
    }

    .card-body {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .chart-container {
        width: 305px;
        height: 306px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .variance-table-wrapper {
        flex: 1;
        min-width: 220px;
        background: var(--backgrounds-and-lines-n-600, #10141b);
        border-radius: 8px;
        overflow: hidden;
    }

    .variance-table {
        width: 100%;
        border-collapse: collapse;
    }

    .variance-table th {
        padding: 8px 12px;
        color: var(--text-and-icons-gray-100, #d1d1d1);
        font-size: 12px;
        font-weight: 400;
        border-bottom: 1px solid var(--backgrounds-and-lines-n-100, #3c485a);
        text-align: left;
    }

    .variance-table th:last-child {
        text-align: right;
    }

    .variance-table td {
        padding: 6px 12px;
        font-size: 12px;
        font-weight: 400;
        text-align: left;
    }

    .variance-table td:last-child {
        text-align: right;
    }

    .td-category {
        color: var(--text-and-icons-gray-100, #d1d1d1);
    }

    .td-value--success {
        color: var(--text-and-icons-green-500, #00bb00);
    }

    .td-value--warning {
        color: var(--text-and-icons-orange-500, #ff9900);
    }

    .td-value--danger {
        color: var(--text-and-icons-red-500, #ff4d4f);
    }

    .apexcharts-tooltip.apexcharts-theme-dark {
        color: var(--text-and-icons-gray-100, #d1d1d1) !important;
        background: var(--backgrounds-and-lines-n-100, #3c485a) !important;
        border: 1px solid var(--text-and-icons-gray-300, #4f5b6d) !important;
    }

    .apexcharts-tooltip.apexcharts-theme-dark .apexcharts-tooltip-series-group {
        background: transparent !important;
    }
`;
// #endregion

const CHART_OPTIONS = {
    chart: {
        type: "donut",
        background: "transparent",
        sparkline: { enabled: true }
    },
    colors: [
        "#e5e7eb",
        "#d1d5db",
        "#c4c9d1",
        "#b2b8c2",
        "#9ca3af",
        "#858d9a",
        "#6b7280",
        "#596170",
        "#4b5563",
        "#374151",
        "#293548",
        "#1f2937",
        "#111827"
    ],
    legend: { show: false },
    dataLabels: { enabled: false },
    tooltip: {
        enabled: true,
        theme: "dark",
        fillSeriesColor: false
    },
    plotOptions: {
        pie: {
            donut: {
                size: "40%",
                labels: { show: false }
            }
        }
    },
    stroke: { width: 2, colors: ["#1e2631"] }
};

export default function BIBuyPlanChartCard({
    title = "BUYING VALUE",
    labels = [],
    series = [],
    varianceRows = [],
    showHeader = true
}) {
    const chartOptions = {
        ...CHART_OPTIONS,
        labels
    };

    return (
        <StyledChartCard className="buyplan-chart-card">
            {showHeader && (
                <>
                    <div className="card-title">{title}</div>
                    <hr className="card-divider" />
                </>
            )}
            <div className="card-body">
                {/* Donut chart (305x306px) */}
                <div className="chart-container">
                    <Chart options={chartOptions} series={series} type="donut" width="305" height="306" />
                </div>

                {/* Category variance table */}
                <div className="variance-table-wrapper">
                    <table className="variance-table">
                        <thead>
                            <tr>
                                <th>Category</th>
                                <th>Variance vs Buy Plan</th>
                            </tr>
                        </thead>
                        <tbody>
                            {varianceRows.map(row => (
                                <tr key={row.key || row.category}>
                                    <td className="td-category">{row.category}</td>
                                    <td className={`td-value--${row.tone || "warning"}`}>{row.variance}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </StyledChartCard>
    );
}
